import useAuthService from "../session/useAuthService";

let allowedDomains = ["artest.betalearnings.com","jde.betalearnings.com", "uniteddocs.betalearnings.com", "app.united-docs.com"];

let allowedProductionDomains = ["3.136.26.136" , "184.169.157.125"];

let URL = "";
if (["localhost", "127.0.0.1"].includes(window.location.hostname)) {

  URL = `http://${window.location.hostname}:8081/`;

} else if (allowedDomains.includes(window.location.hostname)) {
  URL = `https://${window.location.hostname}/unitedDoc_MW/`;
} else if (allowedProductionDomains.includes(window.location.hostname)) {
  URL = `https://${window.location.hostname}:8080/unitedDoc_MW/`;
} else {
  URL = "https://noaccess.com/youHaveNoAccess/";
}

export const changePasswordUrl = `${window.location.origin}/changePassword?signin=`;

export const API_URL = URL;

// export const timeZone = "+05:30";

export const HTTP_HEADERS = {
  "Content-Type": "application/json",
  Authorization: "PRO-JWT",
};

export const REACT_APP_GOOGLE_MAPS_API_KEY='AIzaSyAPA5j0B0ZY84cC02ycRmEsiv6MVHS-U78';



  export const HEADERS = (key) => {
    return {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: "JWT fefege...",
    };
  }
 export const AUTH_HEADERS = () => {
    return {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: useAuthService.getToken(),
    };
  }

